export const CLIENT_ACTION = {
  GET_ALERTS: 'get-alerts',
  NEW_ALERT: 'new-alert',
  SKIP_ALERT: 'skip-alert',
  ERROR_RESPONSE: 'error-response',
} as { [key: string]: AlertsApi.eClientAction }